import { createSelector } from 'reselect'

import viewTypes from 'helpers/enums/viewTypes'
import currentViewSelector from '../ui/currentViewSelector'
import customSlideIdSelector from './custom_slide_id_selector.js'

const drawItIdSelector = state => state.drawIt.entityUID
const matchingPairsIdSelector = state => state.matchingPairsCt.entityUID

const currentActivityIdSelector = createSelector(
	[
		currentViewSelector,
		customSlideIdSelector,
		drawItIdSelector,
		matchingPairsIdSelector,
	],
	(
		currentView,
		customSlideId,
		drawItId,
		matchingPairsId,
	) => {
		const viewsToActivityId = {
			[viewTypes.TIME_TO_CLIMB_CREATION]: customSlideId,
			[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: customSlideId,
			[viewTypes.DRAW_IT_CREATION]: drawItId,
			[viewTypes.DRAW_IT_STANDALONE_CREATION]: drawItId,
			[viewTypes.MATCHING_PAIRS_CREATION]: matchingPairsId,
			[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: matchingPairsId,
		}

		return viewsToActivityId[currentView] || ''
	}
)

export default currentActivityIdSelector
